module.exports = __webpack_public_path__ + "img/baseball.3a58fac5.jpg";